import styled from 'styled-components';

export const PinContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > p {
    margin-bottom: 15px;
  }

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

      & > p {
        margin-bottom: 0;
      }
  `}
`;

// Hosted iframe for PIN display: label above large bold digits
export const PinFrame = styled.iframe`
  width: 100%;
  height: 28px;
  border: none;
`;
